import React from "react";
import { Container } from "../../components/container";

const CITY_GUIDES = [
  {
    title: "arena info",
    description:
      "Everything you need to know before game day! Parking tips, family-friendly entrances, and hidden-in-plain-sight amenities. We make every home game feel a little more like home.",
  },
  {
    title: "guidance",
    description:
      "From where to stay to how to get around, our guidance blends local expertise with family perspective. Discover neighborhoods, routines, and rhythms that fit your lifestyle, not just the travel itinerary.",
  },
  {
    title: "Contact list",
    description:
      "A centralized directory of your team - staff, coaches, operations, and key contacts - kept current and easy to navigate. No more digging through texts or emails to find who to reach.",
  },
  {
    title: "Team schedule",
    description:
      "Stay aligned with your team’s season at a glance. Access key dates and touchpoints that help you plan ahead and feel grounded wherever the schedule takes you.",
  },
];
function TeamCityGuides() {
  return (
    <section
      className="bg-[#F1EBE2] md:pb-28"
      id="team-city-guides"
      aria-label="Team city guides"
    >
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-5 lg:gap-32 justify-items-start">
          <h2 className="font-ppacma text-[56px] md:text-8xl leading-[90%] mt-6">
            <span className="text-black">Team City</span> <br />
            <span className="text-yellow">Guides </span>
          </h2>

          <p className="text-black text-[18px] font-normal leading-[120%] tracking-[0px] self-end max-w-[462px]">
            Your inside track to every city your team calls home. League Life
            brings together trusted local insights, team-specific details, and
            the connections, whether you're arriving for the season or just in
            town for a weekend.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-7 mt-12">
          {CITY_GUIDES.map((guide) => (
            <article key={guide.title}>
              <h3 className="text-[24px] font-montreal font-medium bg-yellow text-white px-[20px] py-[10px] rounded-[60px] w-auto text-center mb-4 justify-self-start leading-[90%]">
                {guide.title}
              </h3>
              <p className="text-black text-base font-normal leading-[120%] tracking-[0px]">
                {guide.description}
              </p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}

export { TeamCityGuides };
